module.exports = __webpack_public_path__ + "img/card_chip.60d1a6d3.png";